const headerTablePaymentScheme = [
  'Scheme ID',
  'Scheme Name',
  'Scheme Description',
  'Action',
];

export default headerTablePaymentScheme;
